import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { wrapDispatch } from "../../Multireducer";
import { getAndSelectDocument as getAndSelectDocumentAction } from "../../Library/actions/libraryActions";

class EntityInfo extends Component {
  constructor(props) {
    super(props);
    this.getAndSelect = this.getAndSelect.bind(this);
  }

  async getAndSelect(sharedId) {
    const { getAndSelectDocument } = this.props;
    getAndSelectDocument(sharedId);
  }

  render() {
    const { entity, tag, classname, children } = this.props;
    return /*#__PURE__*/React.createElement(
    tag,
    { className: classname, onClick: () => this.getAndSelect(entity) },
    children);

  }
}

EntityInfo.defaultProps = {
  entity: '',
  tag: 'div',
  children: '',
  classname: ''
};













export const mapDispatchToProps = (dispatch) =>
bindActionCreators(
{ getAndSelectDocument: getAndSelectDocumentAction },
wrapDispatch(dispatch, 'library'));


export default connect(() => ({}), mapDispatchToProps)(EntityInfo);